import React from 'react';

import styled from 'styled-components';
import { StyledTypography } from 'styles/common';

// TODO: This component is takin too many props and has become confusing,rewrite
export default function Stat({
  value,
  display,
  valueVariant = 'h6',
  valueColor = 'textPrimary',
  displayVariant = 'caption',
  displayColor = 'textSecondary',
  valuePositioning = 'block',
  displayPositioning = 'block',
  bottomGutter = true,
  icon,
  className,
  displayLeftGutter = 0,
}) {
  return (
    <Container className={className}>
      {icon}
      <StyledTypography
        bottomGutter={bottomGutter}
        customColor={valueColor}
        weight={600}
        display={valuePositioning}
        align="center"
        variant={valueVariant}
      >
        {value}
      </StyledTypography>
      <StyledTypography
        customColor={displayColor}
        display={displayPositioning}
        align="center"
        variant={displayVariant}
        leftGutter={displayLeftGutter}
      >
        {display}
      </StyledTypography>
    </Container>
  );
}

const Container = styled.div``;
